import React from "react";

const SurveyReferences = () => {
  return (
    <>
      <h1
        className="font-bold text-[22px] text-center text-[var(--text-color)] pt-1.5"
        style={{ textDecoration: "underline" }}
      >
        References
      </h1>

      <p className="font-[700] text-[13px] py-[10px] md:pl-3 pl-3">
        1. <span className="text-[#dc2626]">Danve A,</span> Alexander S,
        Afinogenova Y, Haims A. Early diagnosis of axial spondyloarthritis among
        patients with chronic back pain using a clinical screening tool and
        referral strategy. Rheumatol Adv Pract. 2025 Jul 28;9(3):rkaf086.
        doi:10.1093/rap/rkaf086.
        <a
          target="_blank"
          href="https://pubmed.ncbi.nlm.nih.gov/40901640"
          rel="noreferrer"
          className="text-[#008eff]"
          style={{ wordBreak: "break-word" }}
        >
          PMID: 40901640
        </a>{" "}
        ; PMCID: PMC12401578.
      </p>

      <p className="font-[700] text-[13px] py-[10px] md:pl-3 pl-3">
        2. Tang Z,
        <span className="text-[#dc2626]"> Danve A.</span> Modified A-Tool: An
        online self-screening tool for axial spondyloarthritis for patients with
        chronic back pain [abstract]. Arthritis Rheumatol. 2025; 77 (suppl 9).{" "}
        <a
          target="_blank"
          href="https://acrabstracts.org/abstract/modified-a-tool-an-online-self-screening-tool-for-axial-spondyloarthritis-for-patients-with-chronic-back-pain/"
          rel="noreferrer"
          className="text-[#008eff]"
          style={{ wordBreak: "break-word" }}
        >
          https://acrabstracts.org/abstract/modified-a-tool-an-online-self-screening-tool-for-axial-spondyloarthritis-for-patients-with-chronic-back-pain/.
        </a>
      </p>
    </>
  );
};
export default SurveyReferences;
